const Error = ({
  error,
  classNames,
}: {
  error?: string;
  classNames?: string;
}) => {
  return <div className={"text-end text-danger " + classNames}>{error}</div>;
};

export default Error;
